import { requests } from '@/lib/axios';
import { IResponse } from '@/utils/CommonInterface';
// import { tokenParam } from '../interface';

export const getDocList = (params:any): Promise<IResponse> => {
  return requests.post('/admin/get-doc-list', params);
}

export const getActorList = (params:any): Promise<IResponse> => {
  return requests.post('/admin/get-actor-list', params);
}


